import React from 'react';
import { useDispatch } from 'react-redux';
import { SettingsActions } from '../../../redux/Settings';
import classes from '../../../data/classes';
import BaseSelector from '../../baseSelector';
import classTypes from '../../../data/types/classes';

const characterSelector = () => {
  const dispatch = useDispatch();

  const handleChange = (data) => {
    dispatch(SettingsActions.setPlayedClass(data.target.value));
  };

  const {
    wizard,
    necromancer,
    barbarian,
    crusader,
    monk,
    witchDoctor,
    demonHunter,
  } = classTypes;

  const options = [
    { name: 'Random', value: 'RANDOM' },
    { name: classes[wizard].displayName, value: classes[wizard].class },
    {
      name: classes[necromancer].displayName,
      value: classes[necromancer].class,
    },
    { name: classes[barbarian].displayName, value: classes[barbarian].class },
    { name: classes[crusader].displayName, value: classes[crusader].class },
    { name: classes[monk].displayName, value: classes[monk].class },
    {
      name: classes[witchDoctor].displayName,
      value: classes[witchDoctor].class,
    },
    {
      name: classes[demonHunter].displayName,
      value: classes[demonHunter].class,
    },
  ];

  return (
    <BaseSelector
      options={options}
      label="Class"
      id="characterSelector"
      onChange={handleChange}
    />
  );
};

export default characterSelector;
